import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { C, Btn, Input, useResponsive } from "../components/UI";
import { useApp } from "../context/AppContext";
import { supabase } from "../lib/supabase";
 
export default function ParaElas() {
  const [searchParams] = useSearchParams();
  const tabFromUrl = searchParams.get("tab");
  const [activeTab, setActiveTab] = useState(tabFromUrl || "cadastro");
  const navigate = useNavigate();
  const { user } = useApp();
  const { isMobile, isTablet } = useResponsive();
 
  useEffect(() => {
    if (tabFromUrl) {
      setActiveTab(tabFromUrl);
    }
  }, [tabFromUrl]);
 
  // Form state for avaliar empresa
  const [avaliacaoData, setAvaliacaoData] = useState({
    empresa: "",
    cargo: "",
    periodo: "",
    avaliacao: "",
    pontos_positivos: "",
    pontos_negativos: "",
    nota: 5
  });
 
  const handleAvaliacaoChange = (e) => {
    setAvaliacaoData({ ...avaliacaoData, [e.target.name]: e.target.value });
  };
 
  // Estado do envio da avaliacao
  const [enviandoAvaliacao, setEnviandoAvaliacao] = useState(false);
  const [erroAvaliacao, setErroAvaliacao] = useState("");
  const [avaliacaoEnviada, setAvaliacaoEnviada] = useState(false);
 
  // Garante que existe uma linha em "mulheres" para esta usuaria
  const getMulherId = async () => {
    const { data: existente } = await supabase
      .from("mulheres")
      .select("id")
      .eq("user_id", user.id)
      .maybeSingle();
 
    if (existente) return existente.id;
 
    const { data: nova, error: erroInsert } = await supabase
      .from("mulheres")
      .insert({
        user_id: user.id,
        email: user.email,
        nome: user.user_metadata?.name || user.email,
        status: "pendente"
      })
      .select("id")
      .single();
 
    if (erroInsert) throw erroInsert;
    return nova.id;
  };
 
  const handleEnviarAvaliacao = async (e) => {
    e.preventDefault();
    setEnviandoAvaliacao(true);
    setErroAvaliacao("");
 
    try {
      const mulherId = await getMulherId();
 
      const { data: empresaId, error: erroEmpresa } = await supabase
        .rpc("buscar_ou_criar_empresa", { p_nome: avaliacaoData.empresa.trim() });
 
      if (erroEmpresa) throw erroEmpresa;
 
      const { error: erroInsert } = await supabase
        .from("avaliacoes")
        .insert({
          empresa_id: empresaId,
          mulher_id: mulherId,
          cargo: avaliacaoData.cargo.trim() || null,
          periodo: avaliacaoData.periodo.trim() || null,
          nota_geral: avaliacaoData.nota,
          comentario: avaliacaoData.avaliacao.trim(),
          pontos_positivos: avaliacaoData.pontos_positivos.trim()
            ? [avaliacaoData.pontos_positivos.trim()]
            : null,
          pontos_negativos: avaliacaoData.pontos_negativos.trim()
            ? [avaliacaoData.pontos_negativos.trim()]
            : null,
          anonima: true,
          status: "pendente"
        });
 
      if (erroInsert) {
        if (erroInsert.code === "23505") {
          setErroAvaliacao("Você já avaliou essa empresa. Cada pessoa pode enviar uma avaliação por empresa.");
        } else {
          setErroAvaliacao("Não foi possível enviar sua avaliação. Tente novamente em alguns instantes.");
        }
        setEnviandoAvaliacao(false);
        return;
      }
 
      setAvaliacaoData({
        empresa: "",
        cargo: "",
        periodo: "",
        avaliacao: "",
        pontos_positivos: "",
        pontos_negativos: "",
        nota: 5
      });
      setAvaliacaoEnviada(true);
    } catch (err) {
      setErroAvaliacao("Não foi possível enviar sua avaliação. Tente novamente em alguns instantes.");
    } finally {
      setEnviandoAvaliacao(false);
    }
  };
 
  const tabs = [
    { id: "cadastro", label: "Cadastro" },
    { id: "empresas", label: "Empresas avaliadas" },
    { id: "avaliar", label: "Avaliar empresa" },
    { id: "vagas", label: "Vagas" },
    { id: "blog", label: "Blog" }
  ];
 
  return (
    <div style={{ minHeight: "100vh", background: C.background }}>
      {/* Hero Section com Tabs */}
      <section style={{ 
        background: C.roseMid,
        padding: isMobile ? "30px 16px 0" : "40px 20px 0",
        textAlign: "center"
      }}>
        <h1 style={{ 
          fontFamily: "'Playfair Display', serif",
          fontSize: isMobile ? 28 : 36,
          fontWeight: 700,
          color: "#fff",
          marginBottom: isMobile ? 20 : 30
        }}>
          Para Elas
        </h1>
 
        {/* Tabs */}
        <div style={{ 
          display: "flex", 
          justifyContent: isMobile ? "flex-start" : "center", 
          gap: 0,
          flexWrap: "nowrap",
          overflowX: "auto",
          WebkitOverflowScrolling: "touch",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          paddingBottom: isMobile ? 0 : 0
        }}>
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              style={{
                padding: isMobile ? "12px 16px" : "16px 28px",
                fontSize: isMobile ? 13 : 15,
                fontWeight: 600,
                background: activeTab === tab.id ? C.background : "transparent",
                color: activeTab === tab.id ? C.roseMid : "#fff",
                border: "none",
                borderRadius: "12px 12px 0 0",
                cursor: "pointer",
                transition: "all 0.2s ease",
                whiteSpace: "nowrap",
                flexShrink: 0
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </section>
 
      {/* Tab Content: Cadastro */}
      {activeTab === "cadastro" && (
        <section style={{ maxWidth: 600, margin: "0 auto", padding: "60px 20px" }}>
          <h2 style={{ 
            fontFamily: "'Playfair Display', serif",
            fontSize: 28,
            color: C.roseMid,
            marginBottom: 12,
            textAlign: "center"
          }}>
            Crie sua conta gratuita
          </h2>
          <p style={{ 
            fontSize: 15, 
            color: C.textSec, 
            textAlign: "center",
            marginBottom: 32
          }}>
            Cadastre-se para avaliar empresas, encontrar vagas e conectar-se com outras mulheres.
          </p>
 
          <div style={{ background: C.surface, borderRadius: 16, padding: 32, border: `1px solid ${C.border}` }}>
            <p style={{ fontSize: 14, fontWeight: 600, color: C.textMain, marginBottom: 16 }}>
              Ao criar sua conta voce pode:
            </p>
            <ul style={{ listStyle: "none", padding: 0, margin: "0 0 28px 0", display: "flex", flexDirection: "column", gap: 12 }}>
              {[
                "Avaliar empresas onde trabalha ou trabalhou",
                "Ler avaliacoes de outras mulheres antes de aceitar uma vaga",
                "Acompanhar vagas em empresas comprometidas com diversidade",
                "Manter seu curriculo disponivel para empresas cadastradas"
              ].map(item => (
                <li key={item} style={{ display: "flex", alignItems: "flex-start", gap: 10, fontSize: 14, color: C.textSec, lineHeight: 1.6 }}>
                  <span style={{ color: C.roseMid, flexShrink: 0 }}>&#9733;</span>
                  {item}
                </li>
              ))}
            </ul>
            <Btn variant="primary" onClick={() => navigate("/cadastro")} style={{ width: "100%", padding: "14px 24px", fontSize: 16 }}>
              Criar minha conta gratis
            </Btn>
          </div>
 
          <p style={{ fontSize: 13, color: C.textSec, textAlign: "center", marginTop: 20 }}>
            Ja tem uma conta? <span style={{ color: C.roseMid, cursor: "pointer" }} onClick={() => navigate("/login")}>Entrar</span>
          </p>
        </section>
      )}
 
      {/* Tab Content: Empresas avaliadas */}
      {activeTab === "empresas" && (
        <section style={{ maxWidth: 1100, margin: "0 auto", padding: "60px 20px" }}>
          <h2 style={{ 
            fontFamily: "'Playfair Display', serif",
            fontSize: 28,
            color: C.roseMid,
            marginBottom: 12,
            textAlign: "center"
          }}>
            Empresas avaliadas
          </h2>
          <p style={{ 
            fontSize: 15, 
            color: C.textSec, 
            textAlign: "center",
            marginBottom: 40
          }}>
            Veja o que outras mulheres estao dizendo sobre as empresas onde trabalharam.
          </p>
 
          {/* Search bar */}
          <div style={{ maxWidth: 500, margin: "0 auto 40px" }}>
            <Input 
              placeholder="Buscar empresa por nome..." 
              style={{ width: "100%" }}
            />
          </div>
 
          {/* Lista de empresas */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: 24 }}>
            {[
              { nome: "TechCorp Brasil", setor: "Tecnologia", nota: 4.5, avaliacoes: 128 },
              { nome: "Marketing Digital SA", setor: "Marketing", nota: 4.2, avaliacoes: 87 },
              { nome: "Banco Inclusivo", setor: "Financeiro", nota: 4.0, avaliacoes: 203 },
              { nome: "Consultoria RH Plus", setor: "Recursos Humanos", nota: 4.7, avaliacoes: 56 },
              { nome: "Saude & Bem-estar", setor: "Saude", nota: 3.8, avaliacoes: 142 },
              { nome: "Educacao Digital", setor: "Educacao", nota: 4.3, avaliacoes: 95 }
            ].map(empresa => (
              <div key={empresa.nome} style={{
                background: C.surface,
                borderRadius: 16,
                padding: 24,
                border: `1px solid ${C.border}`,
                cursor: "pointer",
                transition: "transform 0.2s ease, box-shadow 0.2s ease"
              }}
              onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.boxShadow = "0 8px 24px rgba(0,0,0,0.08)"; }}
              onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
                  <div>
                    <h3 style={{ fontSize: 18, fontWeight: 600, color: C.textMain, marginBottom: 4 }}>{empresa.nome}</h3>
                    <span style={{ fontSize: 13, color: C.textSec }}>{empresa.setor}</span>
                  </div>
                  <div style={{ 
                    background: empresa.nota >= 4 ? "#D1FAE5" : empresa.nota >= 3 ? "#FEF3C7" : "#FEE2E2",
                    color: empresa.nota >= 4 ? "#065F46" : empresa.nota >= 3 ? "#92400E" : "#991B1B",
                    padding: "4px 10px",
                    borderRadius: 8,
                    fontSize: 14,
                    fontWeight: 600
                  }}>
                    {empresa.nota.toFixed(1)}
                  </div>
                </div>
                <p style={{ fontSize: 13, color: C.textSec }}>{empresa.avaliacoes} avaliacoes</p>
              </div>
            ))}
          </div>
        </section>
      )}
 
      {/* Tab Content: Avaliar empresa */}
      {activeTab === "avaliar" && (
        <section style={{ maxWidth: 700, margin: "0 auto", padding: "60px 20px" }}>
          <h2 style={{ 
            fontFamily: "'Playfair Display', serif",
            fontSize: 28,
            color: C.roseMid,
            marginBottom: 12,
            textAlign: "center"
          }}>
            Avaliar uma empresa
          </h2>
          <p style={{ 
            fontSize: 15, 
            color: C.textSec, 
            textAlign: "center",
            marginBottom: 32
          }}>
            Compartilhe sua experiência e ajude outras mulheres a tomarem decisões de carreira mais informadas.
          </p>
 
          {/* Se nao estiver logada, mostrar mensagem para login */}
          {!user ? (
            <div style={{
              background: C.surface,
              borderRadius: 16,
              padding: 40,
              border: `1px solid ${C.border}`,
              textAlign: "center"
            }}>
              <div style={{ 
                width: 80, 
                height: 80, 
                borderRadius: "50%", 
                background: C.rosePale, 
                display: "flex", 
                alignItems: "center", 
                justifyContent: "center",
                margin: "0 auto 24px",
                fontSize: 36
              }}>
                🔒
              </div>
              <h3 style={{ 
                fontSize: 22, 
                fontWeight: 600, 
                color: C.textMain, 
                marginBottom: 12 
              }}>
                Faça login para avaliar
              </h3>
              <p style={{ 
                fontSize: 15, 
                color: C.textSec, 
                marginBottom: 24,
                maxWidth: 400,
                margin: "0 auto 24px"
              }}>
                Para compartilhar sua experiência e ajudar outras mulheres, você precisa estar cadastrada na plataforma.
              </p>
              <div style={{ display: "flex", gap: 12, justifyContent: "center" }}>
                <Btn variant="primary" onClick={() => navigate("/login")}>
                  Entrar
                </Btn>
                <Btn variant="ghost" onClick={() => navigate("/cadastro")}>
                  Criar conta grátis
                </Btn>
              </div>
            </div>
          ) : (
            /* Se estiver logada, mostrar o formulario */
            avaliacaoEnviada ? (
            <div style={{ textAlign: "center", padding: "40px 20px" }}>
              <div style={{
                width: 72,
                height: 72,
                borderRadius: "50%",
                background: "#EAF3DE",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 20px",
                fontSize: 32,
                color: "#3B6D11"
              }}>
                ✓
              </div>
              <h3 style={{ fontSize: 22, fontWeight: 600, color: C.textMain, marginBottom: 12 }}>
                Avaliação enviada!
              </h3>
              <p style={{ fontSize: 15, color: C.textSec, lineHeight: 1.7, maxWidth: 440, margin: "0 auto 24px" }}>
                Obrigada por compartilhar. Nossa equipe analisa sua avaliação antes de publicar — normalmente em até 48 horas.
              </p>
              <Btn variant="primary" onClick={() => setAvaliacaoEnviada(false)}>
                Avaliar outra empresa
              </Btn>
            </div>
            ) : (
            <form onSubmit={handleEnviarAvaliacao} style={{ display: "flex", flexDirection: "column", gap: 20 }}>
            <Input 
              label="Nome da empresa" 
              name="empresa" 
              value={avaliacaoData.empresa} 
              onChange={handleAvaliacaoChange} 
              required 
            />
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
              <Input 
                label="Seu cargo" 
                name="cargo" 
                value={avaliacaoData.cargo} 
                onChange={handleAvaliacaoChange} 
                required 
              />
              <Input 
                label="Periodo trabalhado" 
                name="periodo" 
                value={avaliacaoData.periodo} 
                onChange={handleAvaliacaoChange} 
                placeholder="Ex: 2020 - 2023"
              />
            </div>
            
            {/* Nota */}
            <div>
              <label style={{ fontSize: 14, fontWeight: 500, color: C.textMain, marginBottom: 8, display: "block" }}>
                Nota geral (1 a 5)
              </label>
              <div style={{ display: "flex", gap: 8 }}>
                {[1, 2, 3, 4, 5].map(n => (
                  <button
                    key={n}
                    type="button"
                    onClick={() => setAvaliacaoData({ ...avaliacaoData, nota: n })}
                    style={{
                      width: 48,
                      height: 48,
                      borderRadius: 8,
                      border: `2px solid ${avaliacaoData.nota === n ? C.roseMid : C.border}`,
                      background: avaliacaoData.nota === n ? C.roseMid : C.surface,
                      color: avaliacaoData.nota === n ? "#fff" : C.textMain,
                      fontSize: 18,
                      fontWeight: 600,
                      cursor: "pointer",
                      transition: "all 0.2s ease"
                    }}
                  >
                    {n}
                  </button>
                ))}
              </div>
            </div>
 
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: "block", fontSize: 13, fontWeight: 500, color: C.textSec, marginBottom: 6 }}>
                Como foi sua experiencia geral?
              </label>
              <textarea
                name="avaliacao"
                value={avaliacaoData.avaliacao}
                onChange={handleAvaliacaoChange}
                rows={4}
                required
                style={{ width: "100%", padding: "12px 14px", border: `1px solid ${C.border}`, borderRadius: 10, fontSize: 15, resize: "vertical" }}
              />
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: "block", fontSize: 13, fontWeight: 500, color: C.textSec, marginBottom: 6 }}>
                Pontos positivos
              </label>
              <textarea
                name="pontos_positivos"
                value={avaliacaoData.pontos_positivos}
                onChange={handleAvaliacaoChange}
                rows={3}
                style={{ width: "100%", padding: "12px 14px", border: `1px solid ${C.border}`, borderRadius: 10, fontSize: 15, resize: "vertical" }}
              />
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: "block", fontSize: 13, fontWeight: 500, color: C.textSec, marginBottom: 6 }}>
                Pontos negativos
              </label>
              <textarea
                name="pontos_negativos"
                value={avaliacaoData.pontos_negativos}
                onChange={handleAvaliacaoChange}
                rows={3}
                style={{ width: "100%", padding: "12px 14px", border: `1px solid ${C.border}`, borderRadius: 10, fontSize: 15, resize: "vertical" }}
              />
            </div>
 
            {erroAvaliacao && (
              <div style={{
                background: "#FCEBEB",
                border: "1px solid #F7C1C1",
                borderRadius: 10,
                padding: "12px 14px",
                fontSize: 14,
                color: "#A32D2D",
                lineHeight: 1.6
              }}>
                {erroAvaliacao}
              </div>
            )}
 
            <Btn type="submit" variant="primary" disabled={enviandoAvaliacao} style={{ width: "100%", padding: "14px 24px", fontSize: 16, marginTop: 8, opacity: enviandoAvaliacao ? 0.7 : 1 }}>
              {enviandoAvaliacao ? "Enviando..." : "Enviar avaliação"}
            </Btn>
          </form>
          )
          )}
        </section>
      )}
 
      {/* Tab Content: Vagas */}
      {activeTab === "vagas" && (
        <section style={{ maxWidth: 1100, margin: "0 auto", padding: "60px 20px" }}>
          <h2 style={{ 
            fontFamily: "'Playfair Display', serif",
            fontSize: 28,
            color: C.roseMid,
            marginBottom: 12,
            textAlign: "center"
          }}>
            Vagas para mulheres
          </h2>
          <p style={{ 
            fontSize: 15, 
            color: C.textSec, 
            textAlign: "center",
            marginBottom: 40
          }}>
            Encontre oportunidades em empresas comprometidas com diversidade e inclusao.
          </p>
 
          {/* Filtros */}
          <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: 32, justifyContent: "center" }}>
            {["Todas", "Tecnologia", "Marketing", "Financeiro", "RH", "Saude"].map(filtro => (
              <button
                key={filtro}
                style={{
                  padding: "8px 20px",
                  borderRadius: 20,
                  border: `1px solid ${C.border}`,
                  background: filtro === "Todas" ? C.roseMid : C.surface,
                  color: filtro === "Todas" ? "#fff" : C.textSec,
                  fontSize: 13,
                  cursor: "pointer"
                }}
              >
                {filtro}
              </button>
            ))}
          </div>
 
          {/* Lista de vagas */}
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            {[
              { titulo: "Desenvolvedora Full Stack", empresa: "TechCorp Brasil", local: "Remoto", tipo: "CLT", salario: "R$ 8.000 - R$ 12.000" },
              { titulo: "Analista de Marketing Digital", empresa: "Marketing Digital SA", local: "Sao Paulo, SP", tipo: "CLT", salario: "R$ 5.000 - R$ 7.000" },
              { titulo: "Gerente de Projetos", empresa: "Consultoria RH Plus", local: "Hibrido", tipo: "PJ", salario: "R$ 15.000 - R$ 20.000" },
              { titulo: "UX Designer Senior", empresa: "Educacao Digital", local: "Remoto", tipo: "CLT", salario: "R$ 10.000 - R$ 14.000" },
              { titulo: "Coordenadora de RH", empresa: "Banco Inclusivo", local: "Rio de Janeiro, RJ", tipo: "CLT", salario: "R$ 9.000 - R$ 13.000" }
            ].map((vaga, i) => (
              <div key={i} style={{
                background: C.surface,
                borderRadius: 12,
                padding: 24,
                border: `1px solid ${C.border}`,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 16
              }}>
                <div>
                  <h3 style={{ fontSize: 17, fontWeight: 600, color: C.textMain, marginBottom: 6 }}>{vaga.titulo}</h3>
                  <p style={{ fontSize: 14, color: C.textSec, marginBottom: 8 }}>{vaga.empresa}</p>
                  <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                    <span style={{ fontSize: 12, color: C.textSec, background: C.background, padding: "4px 10px", borderRadius: 4 }}>{vaga.local}</span>
                    <span style={{ fontSize: 12, color: C.textSec, background: C.background, padding: "4px 10px", borderRadius: 4 }}>{vaga.tipo}</span>
                    <span style={{ fontSize: 12, color: C.roseMid, fontWeight: 500 }}>{vaga.salario}</span>
                  </div>
                </div>
                <Btn variant="primary" style={{ padding: "10px 24px", fontSize: 13 }}>
                  Candidatar-se
                </Btn>
              </div>
            ))}
          </div>
        </section>
      )}
 
      {/* Tab Content: Blog */}
      {activeTab === "blog" && (
        <section style={{ maxWidth: 900, margin: "0 auto", padding: "60px 20px" }}>
          <h2 style={{ 
            fontFamily: "'Playfair Display', serif",
            fontSize: 28,
            color: C.roseMid,
            marginBottom: 12,
            textAlign: "center"
          }}>
            Blog WoMom
          </h2>
          <p style={{ 
            fontSize: 15, 
            color: C.textSec, 
            textAlign: "center",
            marginBottom: 40
          }}>
            Conteúdos sobre carreira, diversidade e empoderamento feminino no mercado de trabalho.
          </p>
 
          {/* Artigo Principal */}
          <article style={{
            background: C.surface,
            borderRadius: 16,
            overflow: "hidden",
            border: `1px solid ${C.border}`,
          }}>
            <img 
              src="/images/blog-salario-mulheres.png" 
              alt="Mulheres segurando cartazes sobre igualdade de gênero" 
              style={{ width: "100%", height: 400, objectFit: "cover" }}
            />
            <div style={{ padding: 32 }}>
              <div style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 16 }}>
                <span style={{ 
                  fontSize: 11, 
                  fontWeight: 600, 
                  color: C.roseMid, 
                  background: C.rosePale, 
                  padding: "4px 10px", 
                  borderRadius: 4,
                  textTransform: "uppercase"
                }}>
                  Igualdade Salarial
                </span>
                <span style={{ fontSize: 12, color: C.textSec }}>Maio 2025</span>
              </div>
              
              <h1 style={{ 
                fontSize: 28, 
                fontWeight: 700, 
                color: C.textMain, 
                marginBottom: 24, 
                lineHeight: 1.3,
                fontFamily: "'Playfair Display', serif"
              }}>
                Trabalha igual, ganha menos: o que os dados dizem sobre o salário da mulher no Brasil
              </h1>
              
              <div style={{ fontSize: 16, color: C.textSec, lineHeight: 1.8 }}>
                <p style={{ marginBottom: 20 }}>
                  Você faz o mesmo trabalho que seu colega. Tem a mesma formação, a mesma experiência, a mesma entrega. E ainda assim, no final do mês, o salário cai diferente na conta.
                </p>
                <p style={{ marginBottom: 20, fontWeight: 600, color: C.textMain }}>
                  Não é impressão. É dado.
                </p>
 
                <h2 style={{ fontSize: 20, fontWeight: 700, color: C.roseMid, marginTop: 32, marginBottom: 16 }}>
                  O que a pesquisa mostra
                </h2>
                <p style={{ marginBottom: 20 }}>
                  Segundo o 3º Relatório de Transparência Salarial, divulgado pelo Ministério do Trabalho em abril de 2025, as mulheres no setor privado brasileiro ganham <strong>20,9% a menos</strong> do que os homens. Em valores concretos: homens recebem em média R$ 4.745, mulheres R$ 3.755.
                </p>
                <p style={{ marginBottom: 20 }}>
                  Para as mulheres negras, a distância é ainda maior. O salário médio cai para R$ 2.864 — o que significa que um homem não negro ganha <strong>110% a mais</strong> do que uma mulher negra na mesma função.
                </p>
                <p style={{ marginBottom: 20 }}>
                  E quando as mulheres chegam às posições de liderança? A diferença não some — ela aumenta. Em cargos de direção e gerência, as mulheres recebem <strong>26,8% a menos</strong> do que os homens nos mesmos cargos.
                </p>
 
                <h2 style={{ fontSize: 20, fontWeight: 700, color: C.roseMid, marginTop: 32, marginBottom: 16 }}>
                  O que esses números custam ao país
                </h2>
                <p style={{ marginBottom: 20 }}>
                  O levantamento traz um cálculo que impressiona: se as mulheres recebessem o mesmo que os homens pelas mesmas funções, <strong>R$ 95 bilhões</strong> teriam entrado na economia brasileira só em 2024. A OIT vai além e estima que políticas plenas de igualdade de gênero poderiam ampliar a economia do Brasil em até <strong>R$ 382 bilhões</strong>.
                </p>
                <p style={{ marginBottom: 20 }}>
                  Mais mulheres trabalhando — esse avanço existe. O número de trabalhadoras ocupadas cresceu de 38,8 milhões em 2015 para 44,8 milhões em 2024. O problema é que o crescimento da presença não veio acompanhado do crescimento do reconhecimento.
                </p>
 
                <h2 style={{ fontSize: 20, fontWeight: 700, color: C.roseMid, marginTop: 32, marginBottom: 16 }}>
                  Por que isso ainda acontece?
                </h2>
                <p style={{ marginBottom: 20 }}>
                  Parte da resposta está nas estruturas. Menos de metade das empresas pesquisadas oferecem auxílio-creche (22%) ou licença-maternidade estendida (21,2%). Apenas 30,7% têm políticas de apoio à parentalidade de mulheres. Sem suporte, a responsabilidade de cuidar recai sobre elas — e isso tem preço na carreira e no contracheque.
                </p>
                <p style={{ marginBottom: 20 }}>
                  A Lei da Igualdade Salarial, sancionada em 2023, obriga empresas com mais de 100 funcionários a publicar dados salariais e adotar medidas concretas de equidade. É um passo. Mas dado e lei não mudam cultura sozinhos.
                </p>
 
                <h2 style={{ fontSize: 20, fontWeight: 700, color: C.roseMid, marginTop: 32, marginBottom: 16 }}>
                  Transparência é o começo
                </h2>
                <p style={{ marginBottom: 20 }}>
                  Saber o que as empresas pagam — e o que outras mulheres viveram dentro delas — é uma das formas mais diretas de enfrentar essa desigualdade. <strong>Informação é poder.</strong> E compartilhar experiências é uma forma de distribuir esse poder.
                </p>
 
                <div style={{ 
                  marginTop: 32, 
                  paddingTop: 20, 
                  borderTop: `1px solid ${C.border}`,
                  fontSize: 13,
                  color: C.textSec
                }}>
                  <strong>Fontes:</strong> Relatório de Transparência Salarial (MTE, 2025) | DIEESE (2025) | OIT | Banco Mundial
                </div>
              </div>
            </div>
          </article>
 
          {/* Artigo 2 - Maternidade e Carreira */}
          <article style={{
            background: C.surface,
            borderRadius: 16,
            overflow: "hidden",
            border: `1px solid ${C.border}`,
            marginTop: 40
          }}>
            <img 
              src="/images/blog-maternidade-carreira.png" 
              alt="Mãe feliz segurando seu filho" 
              style={{ width: "100%", height: 400, objectFit: "cover" }}
            />
            <div style={{ padding: 32 }}>
              <div style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 16 }}>
                <span style={{ 
                  fontSize: 11, 
                  fontWeight: 600, 
                  color: C.roseMid, 
                  background: C.rosePale, 
                  padding: "4px 10px", 
                  borderRadius: 4,
                  textTransform: "uppercase"
                }}>
                  Maternidade
                </span>
                <span style={{ fontSize: 12, color: C.textSec }}>Maio 2025</span>
              </div>
              
              <h1 style={{ 
                fontSize: 28, 
                fontWeight: 700, 
                color: C.textMain, 
                marginBottom: 24, 
                lineHeight: 1.3,
                fontFamily: "'Playfair Display', serif"
              }}>
                Ser mãe não deveria custar uma carreira — mas no Brasil ainda custa
              </h1>
              
              <div style={{ fontSize: 16, color: C.textSec, lineHeight: 1.8 }}>
                <p style={{ marginBottom: 20 }}>
                  Tem um momento que muitas mulheres conhecem bem: o instante em que percebem que a maternidade mudou como são vistas no trabalho. Às vezes é sutil — uma promoção que não veio, uma reunião importante que parou de chegar. Às vezes é explícito — a pergunta do recrutador sobre se planeja ter filhos, o contrato que não foi renovado depois da licença.
                </p>
                <p style={{ marginBottom: 20, fontWeight: 600, color: C.textMain }}>
                  Não é paranoia. É padrão. E os dados provam.
                </p>
 
                <h2 style={{ fontSize: 20, fontWeight: 700, color: C.roseMid, marginTop: 32, marginBottom: 16 }}>
                  O que a pesquisa revela
                </h2>
                <p style={{ marginBottom: 20 }}>
                  Uma pesquisa da Catho realizada em 2025 ouviu mães em todo o Brasil e o retrato é duro:
                </p>
                <ul style={{ marginBottom: 20, paddingLeft: 20 }}>
                  <li style={{ marginBottom: 8 }}><strong>60% das mães estão fora do mercado de trabalho</strong> — queda de 8% em relação a 2024, mas ainda um número altíssimo</li>
                  <li style={{ marginBottom: 8 }}>Das que estão empregadas, quase <strong>60% ocupam cargos operacionais</strong> e apenas <strong>15% chegam a posições de liderança</strong></li>
                  <li style={{ marginBottom: 8 }}><strong>94,8% nunca foram promovidas</strong> enquanto estavam grávidas ou durante a licença-maternidade</li>
                  <li style={{ marginBottom: 8 }}><strong>83,7% já foram questionadas</strong> por recrutadores sobre planos de ter filhos — prática ilegal no Brasil</li>
                  <li style={{ marginBottom: 8 }}><strong>38% acreditam ou sabem que recebem menos</strong> do que colegas no mesmo cargo por serem mães</li>
                  <li style={{ marginBottom: 8 }}><strong>50,3% deixaram de ir a reuniões escolares</strong> ou consultas médicas dos filhos com medo de perder o emprego</li>
                </ul>
 
                <h2 style={{ fontSize: 20, fontWeight: 700, color: C.roseMid, marginTop: 32, marginBottom: 16 }}>
                  A sobrecarga invisível
                </h2>
                <p style={{ marginBottom: 20 }}>
                  Por trás desses números há uma realidade que muitas mulheres carregam em silêncio: a ausência de rede de apoio. Cerca de <strong>20% das mães relatam não ter ninguém</strong> para dividir as responsabilidades. Entre as que têm algum suporte, <strong>60% dependem de uma única pessoa</strong>.
                </p>
                <p style={{ marginBottom: 20 }}>
                  Ao mesmo tempo, <strong>90% consideram fundamental ter essa rede</strong> para conseguir equilibrar maternidade e trabalho. O problema não é falta de vontade — é falta de estrutura.
                </p>
 
                <h2 style={{ fontSize: 20, fontWeight: 700, color: C.roseMid, marginTop: 32, marginBottom: 16 }}>
                  O que as empresas (ainda não) fazem
                </h2>
                <p style={{ marginBottom: 20 }}>
                  Os benefícios mais desejados pelas mães são simples: <strong>horário flexível (24,1%)</strong>, <strong>plano de saúde para dependentes (22,4%)</strong> e <strong>trabalho híbrido (15,1%)</strong>. Mas para a maioria, essas condições ainda são exceção.
                </p>
                <p style={{ marginBottom: 20 }}>
                  Empresas que oferecem suporte real à parentalidade não estão apenas sendo "bonzinhas" — estão retendo talento, reduzindo rotatividade e construindo ambientes onde mulheres conseguem, de fato, crescer.
                </p>
 
                <h2 style={{ fontSize: 20, fontWeight: 700, color: C.roseMid, marginTop: 32, marginBottom: 16 }}>
                  O que muda quando as mulheres falam
                </h2>
                <p style={{ marginBottom: 20 }}>
                  A invisibilidade desses dados é parte do problema. Quando não se fala, parece que é caso isolado. Quando se fala — em pesquisas, em avaliações, em conversas honestas entre mulheres — fica claro que é estrutural.
                </p>
                <p style={{ marginBottom: 20 }}>
                  <strong>E estrutura pode ser mudada. Mas só quando é nomeada.</strong>
                </p>
 
                <div style={{ 
                  marginTop: 32, 
                  paddingTop: 20, 
                  borderTop: `1px solid ${C.border}`,
                  fontSize: 13,
                  color: C.textSec
                }}>
                  <strong>Fontes:</strong> Pesquisa Catho — Mães no Mercado de Trabalho (2025) | IBGE Censo Demográfico | DIEESE (2025)
                </div>
              </div>
            </div>
          </article>
        </section>
      )}
    </div>
  );
}
